module.exports = __webpack_public_path__ + "static/media/logo.05ed58a2.png";